import React, { useState } from "react";
import Header from "../../components/header/Header";
import Footer from "../../components/footer/Footer";
import TopButton from "../../components/topButton/TopButton";
import { greeting, contactPageData, socialMediaLinks } from "../../portfolio";
import { Link } from "react-router-dom";
import "./ContactComponent.css";

const contactData = contactPageData.contactSection;
const addressSection = contactPageData.addressSection;
const phoneSection = contactPageData.phoneSection;
const email = "gauthamr2003@gmail.com";

function Contact({ theme, onToggle, isDark }) {
  const [hasCopied, setHasCopied] = useState(false);
  const nightMode = isDark !== false;

  const copyEmail = () => {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(email).catch(() => {});
    }
    setHasCopied(true);
    window.setTimeout(() => setHasCopied(false), 1800);
  };

  return (
    <div
      className={`contact-main contact-observatory ${
        nightMode ? "contact-night" : "contact-paper"
      }`}
    >
      <Header theme={theme} onToggle={onToggle} isDark={isDark} />

      <main className="contact-page-shell">
        <div className="contact-grid-field" aria-hidden="true" />
        <div className="contact-aura contact-aura-one" aria-hidden="true" />
        <div className="contact-aura contact-aura-two" aria-hidden="true" />

        <section className="contact-hero" aria-labelledby="contact-page-title">
          <div
            className="contact-identity-stage"
            aria-label="Portrait and contact status"
          >
            <div
              className="contact-identity-ring contact-identity-ring-one"
              aria-hidden="true"
            />
            <div
              className="contact-identity-ring contact-identity-ring-two"
              aria-hidden="true"
            />
            <div
              className="contact-identity-bracket bracket-top-left"
              aria-hidden="true"
            />
            <div
              className="contact-identity-bracket bracket-top-right"
              aria-hidden="true"
            />
            <div
              className="contact-identity-bracket bracket-bottom-left"
              aria-hidden="true"
            />
            <div
              className="contact-identity-bracket bracket-bottom-right"
              aria-hidden="true"
            />
            <div className="contact-profile-frame">
              <img
                src={require(`../../assets/images/${contactData.profile_image_path}`)}
                alt="Ghibli-style portrait of Sethuram Gautham"
                className="contact-profile-img"
              />
              <div className="contact-profile-scan" aria-hidden="true" />
            </div>
            <div className="contact-identity-callout contact-identity-callout-top">
              <span>HUMAN / IN THE LOOP</span>
              <b>SG · 03</b>
            </div>
            <div className="contact-identity-callout contact-identity-callout-bottom">
              <i /> AVAILABLE FOR NEW SYSTEMS
            </div>
            <span
              className="contact-identity-beacon beacon-a"
              aria-hidden="true"
            />
            <span
              className="contact-identity-beacon beacon-b"
              aria-hidden="true"
            />
          </div>

          <div className="contact-hero-copy">
            <p className="contact-kicker">
              <span className="contact-live-dot" /> CONNECTION CHANNEL / OPEN
            </p>
            <h1 id="contact-page-title">
              {contactData.title}
              <br />
              <em>Let&apos;s make it useful.</em>
            </h1>
            <p className="contact-description">{contactData.description}</p>
            <div className="contact-hero-actions">
              <a className="contact-primary-link" href={`mailto:${email}`}>
                Start a conversation <span>↗</span>
              </a>
              <Link className="contact-secondary-link" to="/projects">
                View selected work <span>↗</span>
              </Link>
              <button
                className="contact-copy-link"
                type="button"
                onClick={copyEmail}
              >
                {hasCopied ? "Email copied" : "Copy email"}{" "}
                <span>{hasCopied ? "✓" : "⧉"}</span>
              </button>
              <span className="contact-copy-status" aria-live="polite">
                {hasCopied
                  ? "Ready to paste."
                  : "Usually replies within 24 hours."}
              </span>
            </div>
            <div className="contact-social-grid" aria-label="Social links">
              {socialMediaLinks.map((media) => (
                <a
                  href={media.link}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="contact-social-link"
                  key={media.name}
                >
                  <i
                    className={`fab ${media.fontAwesomeIcon}`}
                    aria-hidden="true"
                  />
                  <span>{media.name}</span>
                  <b>↗</b>
                </a>
              ))}
            </div>
          </div>
        </section>

        <section className="contact-command-grid" aria-label="Contact options">
          <article className="contact-command-card contact-command-location">
            <div className="contact-command-topline">
              <span>01 / LOCATION</span>
              <i>◎</i>
            </div>
            <h2>{addressSection.subtitle}</h2>
            <p>
              {addressSection.region}, {addressSection.country}
            </p>
            <a
              href={addressSection.location_map_link}
              target="_blank"
              rel="noopener noreferrer"
            >
              Open in maps <span>↗</span>
            </a>
          </article>

          <article className="contact-command-card contact-command-email">
            <div className="contact-command-topline">
              <span>02 / ASYNC CHANNEL</span>
              <i>⌁</i>
            </div>
            <h2>Email</h2>
            <a className="contact-email-address" href={`mailto:${email}`}>
              {email}
            </a>
            <p>Reply within 24 hours.</p>
          </article>

          <article className="contact-command-card contact-command-phone">
            <div className="contact-command-topline">
              <span>03 / DIRECT LINE</span>
              <i>◌</i>
            </div>
            <h2>{phoneSection.title}</h2>
            <a
              className="contact-phone-address"
              href={`tel:${phoneSection.subtitle.replace(/[^+\d]/g, "")}`}
            >
              {phoneSection.subtitle}
            </a>
            <p>For a quick conversation about the work.</p>
          </article>

          <article className="contact-command-card contact-command-resume">
            <div className="contact-command-topline">
              <span>04 / CONTEXT FILE</span>
              <i>↯</i>
            </div>
            <h2>Resume</h2>
            <p>
              A quick record of systems, research, and the outcomes behind them.
            </p>
            <a
              href={greeting.resumeLink}
              target="_blank"
              rel="noopener noreferrer"
            >
              See my resume <span>↗</span>
            </a>
          </article>
        </section>

        <section
          className="contact-terminal-section"
          aria-labelledby="contact-terminal-title"
        >
          <div className="contact-terminal-copy">
            <p className="contact-kicker">
              <span /> CONNECTION ESTABLISHED
            </p>
            <h2 id="contact-terminal-title">
              A difficult problem
              <br />
              <em>is a good place to start.</em>
            </h2>
            <p>
              If you are building something ambitious with agents, local AI,
              data systems, or edge intelligence, I would love to hear what is
              keeping it interesting.
            </p>
          </div>
          <div className="contact-terminal" role="presentation">
            <div className="contact-terminal-bar">
              <span>
                <i />
                <i />
                <i />
              </span>
              <b>outreach.sh</b>
              <em>LIVE</em>
            </div>
            <div className="contact-terminal-body">
              <p>
                <span>$</span> availability --check
              </p>
              <strong>✓ accepting full-time AI/ML roles</strong>
              <p>
                <span>$</span> contact --preferred
              </p>
              <a href={`mailto:${email}`}>
                {email} <b>↗</b>
              </a>
              <p>
                <span>$</span> collaboration --mode
              </p>
              <small>research · engineering · meaningful prototypes</small>
              <div className="contact-terminal-cursor">
                <span>$</span>
                <i />
              </div>
            </div>
          </div>
        </section>
      </main>

      <Footer theme={theme} onToggle={onToggle} isDark={isDark} />
      <TopButton theme={theme} />
    </div>
  );
}

export default Contact;
